module.exports = __webpack_public_path__ + "static/img/murphy.a293f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/murphy.jpg
// module id = gQDR
// module chunks = 0